const getMobileItemCardViewSettings = state => state.definitions.mobileItemCardViewSettings;

export default {
  getMobileItemCardViewSettings
};
